import "../ConnectExchange/ConnectExchange.css";
import FloatingDropdownWithArrow from "../../../sharedPages/CommonComponents/FloatingDropdownWithArrow/FloatingDropdownWithArrow";
import InfoPopup from "../../../sharedPages/CommonComponents/InfoPopup/InfoPopup";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";

const valueIndexMap = {
  0: 0,
  7: 1,
  14: 2,
  30: 3,
};

const OfferATrial = ({
  handleSubmission,
  isLoading,
  options,
  selectedOption,
  setSelectedOption,
}) => {
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if ((user?.leaderCommunity?.subscription || [])?.length) {
      const dbValue = user?.leaderCommunity?.subscription?.[0]?.trialPeriodDays;

      setSelectedOption(options[valueIndexMap[dbValue]]);
    }
  }, [user]);

  return (
    <div>
      <div className="onboardingContentBox top73px">
        <h2 className="title">
          <span>Want to offer a trial?</span>
          <InfoPopup
            contentItems={[
              { text: "Trial", type: "heading" },
              {
                text: `Offering a trial is optional, but recommended.

Most traders see higher conversions when members can try the service before subscribing.`,
                type: "paragraph",
              },
            ]}
          />
        </h2>
        <p className="desc bottom50px">
          It's an effective want to get more members
        </p>
        <div className="mb-20px">
          <FloatingDropdownWithArrow
            className="onboardingInput onboardingDropdownContentWrap"
            label="Select Trial"
            options={options}
            selectedValue={selectedOption}
            setSelectedValue={setSelectedOption}
            focusedAllowed={false}
          />
        </div>
        {selectedOption && (
          <BubbleSvgButton
            className="NextBtn"
            disabled={isLoading}
            isLoading={isLoading}
            onClick={handleSubmission}
            text={"Next"}
            type="button"
            variant="black"
            containerStyling={{
              justifyContent: "center",
            }}
            mainDivStyle={{
              width: "275px",
              height: "55px",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default OfferATrial;
